import { CommonModule } from '@angular/common';

import { GuestRoutingModule } from './guest-routing.module';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LoginComponent } from './login/login.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SignUpComponent } from './sign-up/sign-up.component';


@NgModule({
  declarations: [
    LandingPageComponent,
    LoginComponent,
    RecoverPasswordComponent,
    SignUpComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    GuestRoutingModule
  ]
})
export class GuestModule { }
